
export default {
  namespaced: true,
  unit_deactivation_catalog: {
    title: "Desativação de Instalações | Desativações de Instalações",
    name: "Nome",
    description: "Descrição",
    user_reactivation: "Usuário que reativou",
    user_deactivation: "Usuário que desativou",
    deactivation_reason: "Motivo da desativação",
    attachments: "Anexos"
  },
};

